import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_CurrentStaffMember } from 'redux/modules/currentStaffMember/Actions'
import { TUser } from 'redux/modules/users/TReducer'
import { TStoreTemplate } from 'redux/config/root-types'

const client = RequestMethods()

export interface ISagaWorker_ActivateStaff {
  id: number
}

export default function* SagaWorker_ActivateStaff(action: PayloadAction<ISagaWorker_ActivateStaff>) {
  const { id } = action.payload

  yield put(Actions_CurrentStaffMember.store.showLoader())

  try {
    const user: TStoreTemplate<TUser> = yield call(async () => await client.put<TUser>(`/users/${id}/activate`))
    yield put(Actions_CurrentStaffMember.store.saveCurrentStaffMember(user))

    yield put(
      Actions_Notifications.store.setNotification({ message: 'Stuff member successfully activated', type: 'Success' }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentStaffMember.store.hideLoader())
  }
}
